import { render, staticRenderFns } from "./CoalShedLayout.vue?vue&type=template&id=9d080aee&scoped=true"
import script from "./CoalShedLayout.vue?vue&type=script&lang=js"
export * from "./CoalShedLayout.vue?vue&type=script&lang=js"
import style0 from "./CoalShedLayout.vue?vue&type=style&index=0&id=9d080aee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d080aee",
  null
  
)

export default component.exports